module.exports = __webpack_public_path__ + "img/product-cheetos.f5172db7.png";